import { AccountStatus } from 'types/accounts'
import { useAccountsContext } from './context/useAccountsContext'

export const useIsSuspendedAccount = () => {
  const { currentAccount } = useAccountsContext()
  return currentAccount?.status === AccountStatus.SUSPENDED
}
